import React from "react";
import { Edit } from "react-admin";
import { EditActions } from "../../common/form/FormActions";
import { MasterFleetManagerForm } from "./MasterFleetManagerForm";
import { useNotification } from "../../../common/hooks/useNotification";
import { FormToolbar } from "../../common/form/FormToolbar";
import permissionNames from "../../../common/auth/access-control/permissionNames";
import { useAppData } from "../../../common/hooks/useAppData";
import { useActionPermissions } from "../../../common/auth/useActionPermissions";
import { useFieldPermissions } from "../../../common/hooks/useFieldPermissions";
import { protectedEntities } from "../../../common/auth/permissions";
import { FieldPermissionsContext } from "../../common/field-permissions/FieldPermissionsContext";

interface IMasterFleetManagerCreateProps {}

export const MasterFleetManagerEdit = (
  props: IMasterFleetManagerCreateProps
) => {
  const notify = useNotification(props, "editSuccess");
  const permissions = useActionPermissions();
  const roles =
    useAppData((x) => x.roles)?.map((x) => ({ id: x.name, name: x.name })) ??
    [];
  const fieldPermissions = useFieldPermissions(
    protectedEntities.MasterFleetManager,
    (x) => x.edit
  );

  return (
    <FieldPermissionsContext.Provider value={fieldPermissions}>
      <Edit
        {...props}
        actions={<EditActions />}
        transform={(record) => {
          if (record.roleId && !record.role) {
            record.role = roles.find((x) => x.id === record.roleId)?.name;
          }

          return record;
        }}
        mutationMode="pessimistic"
        onSuccess={notify}
        title="resources.master-fleet-managers.title.edit">
        <MasterFleetManagerForm
          isEdit
          toolbar={
            <FormToolbar
              showDeleteButton={
                permissions &&
                permissions[permissionNames.admin.fleetManagers.main] &&
                permissions[permissionNames.admin.fleetManagers.delete]
              }
            />
          }
        />
      </Edit>
    </FieldPermissionsContext.Provider>
  );
};
